export default {
    HAS_UNSAVED_DATA: "У вас есть несохраненные данные. Вы уверены, что хотите уйти?"
};
